import { render, staticRenderFns } from "./MiraKpiTileGrid.vue?vue&type=template&id=218a3c4e&scoped=true&"
import script from "./MiraKpiTileGrid.vue?vue&type=script&lang=ts&"
export * from "./MiraKpiTileGrid.vue?vue&type=script&lang=ts&"
import style0 from "./MiraKpiTileGrid.vue?vue&type=style&index=0&id=218a3c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218a3c4e",
  null
  
)

export default component.exports